<template>
  <v-container grid-list-lg fluid>
    <v-layout column>
      <v-flex v-if="selectedCustomer && selectedCustomer.alert">
        <v-row id="alert-col">
          <v-col>
            <v-alert v-if="selectedCustomer" type="error" border="left" transition="slide-y-transition" dismissible
              class="mb-0 mt-0" v-model="selectedCustomer.alert" color="red">
              <strong>{{ selectedCustomer.note }}</strong>
            </v-alert>
          </v-col>

          <v-col v-if="
            selectedCustomer &&
            selectedCustomer.note &&
            !selectedCustomer.alert
          ">
            <v-alert v-if="selectedCustomer" transition="slide-y-transition" class="mb-0" dark color="blue">
              <div>
                <span class="body-1">Note:</span><span>{{ selectedCustomer.note }}</span>
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
      <v-flex>
        <v-card outlined class="mt-0">
          <v-toolbar dense flat :color="$style.purchase.titlebar">
            <v-toolbar-title> Create Invoice </v-toolbar-title>
            <v-spacer> </v-spacer>
            <v-row justify="end">
              <v-col class="shrink">
                <v-btn color="primary" small :loading="loadingSaveBtn" :disabled="disabled" @click="saveInvoice">{{
                    invoiceTotal | currency
                }} Save</v-btn>
              </v-col>

              <v-col class="shrink">
                <v-btn small text @click.stop.prevent="cancel">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
          <CustomerSection :initValue="initValue" :isCustomer="isCustomer" :type="autoSelectedType"
            :selectCustomerError="selectCustomerError" @reset="selectCustomerError = []" />
        </v-card>
      </v-flex>
      <v-flex>
        <ProductSearchBar @submit="addRow" />
      </v-flex>
      <v-flex>
        <Cart />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import invoiceService from "@/modules/Invoice/service.js";
import donorService from "@/modules/Donors/service.js";
import customerService from "@/modules/Customer/service.js";
import ProductSearchBar from "@/modules/Invoice/components/ProductSearchBar";
import orderService from "@/modules/Order/InHouse/service";
import Cart from "@/modules/Invoice/components/Cart";
import productService from "@/modules/Product/service.js";
import CustomerSection from "@/modules/Invoice/components/CustomerSection.vue";
import { mapActions, mapGetters } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  name: "create-invoice",
  data() {
    return {
      isCustomer: false,
      autoSelectedType: "donor",
      order: null,
      loadingSaveBtn: false,
      loading: true,
      selectCustomerError: [],
      initValue: null,
    };
  },
  components: {
    Cart,
    CustomerSection,
    ProductSearchBar,
  },
  async created() {
    console.log('this.$route.query', this.$route.query)
    this.SetEditInvoiceId(null);
    if (this.$route.query && this.$route.query.DonorId) {
      this.isCustomer = false
      const donor = await donorService.getById(
        this.$route.query.DonorId
      );
      console.log('donor', donor)
      this.initValue = donor.data;
    }

    if (this.$route.query && this.$route.query.CustomerId) {
      this.isCustomer = true
      const customer = await customerService.getById(
        this.$route.query.CustomerId
      );
      console.log('customer', customer)
      this.initValue = customer.data;
    }

    const obj = this.$route.params;
    if (obj && Object.keys(obj).length !== 0) {
      console.log("this.$router", this.$route.params);
      if (obj.type === "purchase") {
        obj.passData.map((val) => {
          this.AddInvoiceDetail({
            ProductId: val.Product.id,
            name: val.Product.name,
            price: val.Product.price,
            total: val.Product.price * val.qty,
            qty: val.qty,
            cost: val.cost | 0,
            imeiNumber: val.imeiNumber,
            previousPrice: val.Product.price,
          });
        });
      }
      if (obj.type === "order") {
        setTimeout(() => {
          this.initValue = obj.passData.Customer;
        }, 300);
        this.order = obj.passData;
        if (obj.passData.OrderDetails.length > 0) {
          obj.passData.OrderDetails.map((val) => {
            this.AddInvoiceDetail({
              ProductId: val.Product.id,
              name: val.name,
              price: val.price,
              total: val.price * val.qty,
              qty: val.qty,
              cost: val.Product.avgCost | val.Product.cost | val.cost,
              imeiNumber: val.imeiNumber,
              previousPrice: val.Product.price,
              Product: val.Product,
              needIMEINumber: val.Product.trackSerialNumber ? true : false,
              type: "order",
            });
          });
        }
      }
    }
  },
  computed: {
    ...mapGetters("invoice", [
      "Invoice",
      "InvoiceDetails",
      "invoiceTotal",
      "getSelectedCustomer",
      "getSelectedCampaign",
    ]),
    selectedCampaign: {
      get: function () {
        return this.getSelectedCampaign;
      },
      set: function (val) {
        this.SetSelectedCampaign(val);
      },
    },
    color() {
      let value = "yellow lighten-4";
      if (parseFloat(this.order.total) !== this.invoiceTotal) {
        value = "red lighten-4";
      }

      if (parseFloat(this.order.total) === this.invoiceTotal) {
        value = "green lighten-4";
      }

      return value;
    },
    disabled() {
      let value = true;
      value = this.InvoiceDetails.length === 0;

      this.InvoiceDetails.map((row) => {
        // console.log('invoice row', row)
        if (row.needIMEINumber && !row.delete) value = true;
      });
      return value;
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
  },
  methods: {
    ...mapActions("invoice", [
      "AddInvoiceDetail",
      "ResetInvoice",
      "SetEditInvoiceId",
      "SetSelectedCustomer",
      "SetSelectedCampaign",
    ]),
    viewOrder() {
      let order = this.order;
      const hashId = hashids.encode(order.id);
      // console.log('hashId', hashId)
      const routeData = this.$router.resolve({
        path: `/global/order/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    cancel() {
      if (this.InvoiceDetails.length > 0) {
        this.$swal({
          title: "Are you sure?",
          text: "You want to cancel this invoice",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            this.ResetInvoice();
            this.$router.go(-1);
          }
        });
      } else {
        this.ResetInvoice();
        this.$router.go(-1);
      }
    },
    saveInvoice() {
      if (this.order) {
        if (parseFloat(this.order.total) !== this.invoiceTotal) {
          this.$swal({
            title: "Are you sure?",
            text: "Order total and invoice total is not matching",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#B71C1C",
            cancelButtonColor: "#43A047",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          }).then((result) => {
            console.log("result", result);
            if (result.value) {
              this.continueSaving();
            }
          });
        } else {
          this.continueSaving();
        }
      } else {
        console.log("im herer");
        this.continueSaving();
      }
    },
    continueSaving() {
      console.log('invoice', this.Invoice)
      console.log('ere', this.selectedCustomer)
      if (this.isCustomer) {
        this.Invoice.CustomerId = this.selectedCustomer.id
        if (!this.Invoice.CustomerId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Parent");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Parent is not selected!",
            });
          return false;
        } else {
          // this.Invoice.DonorId = this.sele
          console.log('ere', this.selectedCustomer)
        }
      } else {
        this.Invoice.DonorId = this.selectedCustomer.id
        if (!this.Invoice.DonorId) {
          this.selectCustomerError = [];
          this.selectCustomerError.push("Please Select Donor");
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "Donor is not selected!",
            });
          return false;
        }
      }

      if (this.InvoiceDetails) {
        var filterInvoiceDetail = this.InvoiceDetails.filter(function (item) {
          if (!item.delete) {
            return item;
          }
        });

        this.loadingSaveBtn = true;
        let saveInvoice = this.Invoice;
        console.log('saveInvoicesaveInvoice', saveInvoice)
        if (this.getSelectedCampaign) {
          saveInvoice.CampaignId = this.getSelectedCampaign.id
        }

        saveInvoice.InvoiceDetails = filterInvoiceDetail;
        const completeDate = new Date();
        return invoiceService
          .create(saveInvoice)
          .then(() => {
            if (this.order) {
              orderService.updateStatus(this.order.id, {
                completeDate: completeDate,
              });
            }

            productService.resetCache();
            this.order = null;
            this.ResetInvoice();
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Invoice was created!",
              });
            this.loadingSaveBtn = false;
            this.$router.go(-1);
          })
          .catch((error) => {
            console.log("error creating invoice", error);
            this.loadingSaveBtn = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 6000,
              })
              .fire({
                icon: "error",
                title: error.data.message,
              });
          });
      }
    },
    addRow(val) {
      if (val) {
        this.AddInvoiceDetail({
          ProductId: val.id,
          name: val.Bar.name,
          price: val.Bar.price,
          total: val.Bar.price * val.Bar.qty,
          qty: val.Bar.qty,
          cost: val.cost | 0,
          imeiNumber: val.imeiNumber,
          previousPrice: val.Bar.price,
        });
      }
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header__icon {
  margin-top: -10px;
}
</style>
